var path = 'areas/users/views/auth_provider.html';
var html = "<div> <div ng-bind-html-template=linkHtml></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/users/views/auth_provider.html
// module id = 1007
// module chunks = 1